export default __webpack_public_path__ + "static/media/photo--lg--0.efbfee04.jpg";